import { Box, VStack, Checkbox, Input, Select, Text } from "@chakra-ui/react";

interface FilterPanelProps {
  search?: string;
  checkboxes: {
    active: boolean;
    inProgress: boolean;
    completed: boolean;
  };
  timeRange?: string;
  onFilterChange: (filters: {
    search?: string;
    checkboxes: {
      active: boolean;
      inProgress: boolean;
      completed: boolean;
    };
    timeRange?: string;
  }) => void;
}

export const FilterPanel = ({
  search,
  checkboxes,
  timeRange,
  onFilterChange,
}: FilterPanelProps) => {
  return (
    <Box p={4}>
      <VStack align="start" spacing={4}>
        {/* Search Input */}
        <Input
          placeholder="Search by name or display name"
          value={search}
          onChange={(e) =>
            onFilterChange({
              ...{ search: e.target.value, checkboxes, timeRange },
            })
          }
          focusBorderColor="brand.500"
          color="white"
          _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
        />

        {/* Status Filters */}
        <Text fontWeight="bold" color="white">Status</Text>
        <Checkbox
          isChecked={checkboxes.active}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, active: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
        >
          Active
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.inProgress}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, inProgress: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
        >
          In Progress
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.completed}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, completed: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
        >
          Completed
        </Checkbox>

        {/* Time Range Select */}
        <Select
          placeholder="Select Time Range"
          value={timeRange}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes,
              timeRange: e.target.value,
            })
          }
          focusBorderColor="brand.500"
          color="white"
          bg="rgba(0, 0, 0, 0.3)"
          border="1px solid rgba(255, 255, 255, 0.3)"
          _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
        >
          <option value="time-all" style={{ backgroundColor: '#2D3748', color: 'white' }}>All Time</option>
          <option value="time-24h" style={{ backgroundColor: '#2D3748', color: 'white' }}>Last 24 Hours</option>
          <option value="time-7d" style={{ backgroundColor: '#2D3748', color: 'white' }}>Last 7 Days</option>
          <option value="time-15d" style={{ backgroundColor: '#2D3748', color: 'white' }}>Last 15 Days</option>
          <option value="time-30d" style={{ backgroundColor: '#2D3748', color: 'white' }}>Last 30 Days</option>
        </Select>
      </VStack>
    </Box>
  );
};
